import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _CommunitySection_brand;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { tracked } from "@glimmer/tracking";
import { setOwner } from "@ember/application";
import { service } from "@ember/service";
import AboutSectionLink from "discourse/lib/sidebar/common/community-section/about-section-link";
import BadgesSectionLink from "discourse/lib/sidebar/common/community-section/badges-section-link";
import EverythingSectionLink from "discourse/lib/sidebar/common/community-section/everything-section-link";
import FAQSectionLink from "discourse/lib/sidebar/common/community-section/faq-section-link";
import GroupsSectionLink from "discourse/lib/sidebar/common/community-section/groups-section-link";
import UsersSectionLink from "discourse/lib/sidebar/common/community-section/users-section-link";
import { customSectionLinks, secondaryCustomSectionLinks } from "discourse/lib/sidebar/custom-community-section-links";
import SectionLink from "discourse/lib/sidebar/section-link";
import AdminRevampSectionLink from "discourse/lib/sidebar/user/community-section/admin-revamp-section-link";
import AdminSectionLink from "discourse/lib/sidebar/user/community-section/admin-section-link";
import MyPostsSectionLink from "discourse/lib/sidebar/user/community-section/my-posts-section-link";
import ReviewSectionLink from "discourse/lib/sidebar/user/community-section/review-section-link";
const SPECIAL_LINKS_MAP = {
  "/latest": EverythingSectionLink,
  "/about": AboutSectionLink,
  "/u": UsersSectionLink,
  "/faq": FAQSectionLink,
  "/my/activity": MyPostsSectionLink,
  "/review": ReviewSectionLink,
  "/badges": BadgesSectionLink,
  "/admin": AdminSectionLink,
  "/admin-revamp": AdminRevampSectionLink,
  "/g": GroupsSectionLink
};
let CommunitySection = (_class = (_CommunitySection_brand = /*#__PURE__*/new WeakSet(), class CommunitySection {
  constructor(_ref) {
    let {
      section,
      owner
    } = _ref;
    _classPrivateMethodInitSpec(this, _CommunitySection_brand);
    _initializerDefineProperty(this, "appEvents", _descriptor, this);
    _initializerDefineProperty(this, "currentUser", _descriptor2, this);
    _initializerDefineProperty(this, "modal", _descriptor3, this);
    _initializerDefineProperty(this, "router", _descriptor4, this);
    _initializerDefineProperty(this, "siteSettings", _descriptor5, this);
    _initializerDefineProperty(this, "topicTrackingState", _descriptor6, this);
    _initializerDefineProperty(this, "links", _descriptor7, this);
    _initializerDefineProperty(this, "moreLinks", _descriptor8, this);
    _defineProperty(this, "hideSectionHeader", true);
    setOwner(this, owner);
    this.section = section;
    this.slug = section.slug;
    this.callbackId = this.topicTrackingState?.onStateChange(() => {
      this.links.forEach(link => {
        if (link.onTopicTrackingStateChange) {
          link.onTopicTrackingStateChange();
        }
      });
    });
    this.apiLinks = customSectionLinks.concat(secondaryCustomSectionLinks).map(link => _assertClassBrand(_CommunitySection_brand, this, _initializeSectionLink).call(this, link, {
      inMoreDrawer: true
    }));
    this.links = this.section.links.reduce((filtered, link) => {
      if (link.segment === "primary") {
        const generatedLink = _assertClassBrand(_CommunitySection_brand, this, _generateLink).call(this, link);
        if (generatedLink) {
          filtered.push(generatedLink);
        }
      }
      return filtered;
    }, []);
    this.moreLinks = this.section.links.reduce((filtered, link) => {
      if (link.segment === "secondary") {
        const generatedLink = _assertClassBrand(_CommunitySection_brand, this, _generateLink).call(this, link, true);
        if (generatedLink) {
          filtered.push(generatedLink);
        }
      }
      return filtered;
    }, []).concat(this.apiLinks);
  }
  teardown() {
    if (this.callbackId) {
      this.topicTrackingState.offStateChange(this.callbackId);
    }
    [...this.links, ...this.moreLinks].forEach(sectionLink => {
      sectionLink.teardown?.();
    });
  }
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "appEvents", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "modal", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "siteSettings", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "topicTrackingState", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "links", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "moreLinks", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
function _generateLink(link) {
  let inMoreDrawer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const sectionLinkClass = SPECIAL_LINKS_MAP[link.value];
  if (sectionLinkClass) {
    return _assertClassBrand(_CommunitySection_brand, this, _initializeSectionLink).call(this, sectionLinkClass, inMoreDrawer, link.name, link.icon);
  } else {
    return new SectionLink(link, this, this.router);
  }
}
function _initializeSectionLink(sectionLinkClass, inMoreDrawer, overridenName, overridenIcon) {
  if (this.router.isDestroying) {
    return;
  }
  return new sectionLinkClass({
    topicTrackingState: this.topicTrackingState,
    currentUser: this.currentUser,
    appEvents: this.appEvents,
    router: this.router,
    siteSettings: this.siteSettings,
    inMoreDrawer,
    overridenName,
    overridenIcon
  });
}
export { CommunitySection as default };